import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

/* Platform-wide audit log — read-only.
 *
 * Mirrors companyPlanServices.js (same base query, same token key) so it
 * behaves like every other service here. There are no mutations by design:
 * the backend router exposes GET only, because an audit trail the dashboard
 * could rewrite would not be worth keeping.
 *
 * The filter vocabulary is fetched from the server rather than hardcoded a
 * second time here — the controller owns the closed set, and a local copy
 * would drift out of step with it the first time a new table starts writing
 * audit rows.
 */
export const auditLogApi = createApi({
    reducerPath: 'auditLogApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api/audit-logs`,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('prona_userToken');
            if (token) headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['AuditLogs', 'AuditFilters'],
    endpoints: (build) => ({
        getAuditLogs: build.query({
            query: (params = {}) => {
                /* Empty strings are what the "All" option in each dropdown
                   yields. Sending them would be harmless — the controller
                   drops anything outside its vocabulary — but stripping them
                   keeps one cache key per real filter combination instead of
                   one per way of spelling "no filter". */
                const clean = Object.fromEntries(
                    Object.entries(params).filter(
                        ([, v]) => v !== '' && v !== null && v !== undefined
                    )
                );
                return { url: '/', params: clean };
            },
            providesTags: ['AuditLogs'],
        }),

        getAuditLogFilters: build.query({
            query: () => '/filters',
            providesTags: ['AuditFilters'],
        }),
    }),
});

export const { useGetAuditLogsQuery, useGetAuditLogFiltersQuery } = auditLogApi;
